import { TbLoader3 } from "react-icons/tb";

interface LoaderProps {
  text?: string;
}

export function Loader({ text = "Loading Layer Data" }: LoaderProps) {
  return (
    <>
      {/* Backdrop overlay - covers everything */}
      <div className="fixed inset-0 bg-black/50 z-[2020]" />

      {/* Loader content - appears above backdrop */}
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[2021]">
        <div className="bg-white rounded-[20px] shadow-[0px_0px_24px_0px_rgba(0,0,0,0.08)] px-4 py-4">
          <div className="flex flex-row items-center gap-3">
            <div className="flex items-center justify-center w-7 h-7">
              <TbLoader3
                size={20}
                className="custom-marian-blue animate-spin"
              />
            </div>
            <div className="font-bold text-[16px] custom-text-onyx leading-normal whitespace-nowrap text-base">
              {text}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
